import { i18n } from '@fs/zion-locale'

export default {
  heading: () => i18n.t('ImageGroupNumberSearchDialog.heading.imageGroupNumberSearch', 'Image Group Number Search'),
  label: () => i18n.t('ImageGroupNumberSearchDialog.label.imageGroupNumber', 'Image Group Number'),
  listHeading: (variables) =>
    i18n.t('ImageGroupNumberSearchDialog.heading.', 'Volume sets containing group {imageGroupNumber}:', variables),
  noVolumeSetsFound: () =>
    i18n.t(
      'ImageGroupNumberSearchDialog.heading.noVolumeSetsFound',
      'No volume sets found containing that image group number.'
    ),
  search: () => i18n.t('ImageGroupNumberSearchDialog.button.search', 'Search'),
}
